<template>
  <div class="items-wrap">
    <div class="public-breadcrumb">
      {{ $t("Welcome") }} > {{ $t("lcd.Template.TemplateManage") }} >
      <span style="color: #3461ff">{{ $t("lcd.Template.PopTemplate") }}</span>
    </div>
    <div class="top">
      <div class="left">
        <el-button
          icon="el-icon-plus"
          class="more-btn"
          size="small"
          @click="addPopClick({}, 'add')"
        >
          <span>{{ $t("lcd.Template.Add PopTemplate") }}</span>
        </el-button>
        <el-button
          class="more-btn"
          size="small"
          @click="openAutoTemplateDialog"
          v-if="userData.userRoleId == 1"
          >{{$t('lcd.systemParameters.autoTemplate')}}
        </el-button>
        <el-button
          class="more-btn"
          size="small"
          @click="autoTemplateList"
          v-if="userData.userRoleId == 1"
          >{{$t('lcd.systemParameters.autoTemplateList')}}
        </el-button>
      </div>
      <div class="right">
        <el-select
          v-model="pageParams.activeState"
          style="width: 150px; margin: 0 10px 0 0"
          size="small"
          clearable
          :placeholder="$t('lcd.material.Please select template publish status')"
          v-if="activeName != 'third'"
          @change="getList"
        >
          <el-option
            v-for="item in activeStateList"
            :key="item.codeValue"
            :label="item.codeName"
            :value="item.codeValue"
          >
          </el-option>
        </el-select>
        <!-- <el-select
          v-model="pageParams.state"
          style="width: 150px; margin: 0 10px 0 0"
          size="small"
          clearable
          placeholder="请选择模板使用状态"
          v-if="activeName != 'third'"
          @change="getList"
        >
          <el-option
            v-for="item in stateList"
            :key="item.codeValue"
            :label="item.codeName"
            :value="item.codeValue"
          >
          </el-option>
        </el-select> -->
        <el-select
          v-model="pageParams.labelType"
          style="width: 150px; margin: 0 10px 0 0"
          size="small"
          clearable
          :placeholder="$t('lcd.Template.Please Select Template LabelType')"
          v-if="activeName != 'third'"
          @change="getList"
        >
          <el-option
            v-for="item in labelTypeList"
            :key="item.codeId"
            :label="item.codeName"
            :value="item.codeId"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="pageParams.templateSize"
          style="width: 150px; margin: 0 10px 0 0"
          size="small"
          clearable
          :placeholder="$t('lcd.Template.Please Select Template Resolution')"
          @change="getList"
        >
          <el-option
            v-for="item in pixelsList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-input
          clearable
          prefix-icon="el-icon-search"
          size="small"
          ref="search-val"
          style="width: 160px"
          :placeholder="$t('lcd.Template.Please Enter Template Name')"
          v-model="pageParams.templateName"
          @change="getList"
        />
      </div>
    </div>
    <div class="center">
      <div class="center-title">
        <span class="number"
          >{{ $t("itemsScenarios.Record") }}: {{ tableInfo.total }}</span
        >
      </div>
      <div style="padding: 50px 20px 10px">
        <el-row :gutter="18">
          <el-col
            :xs="12"
            :sm="8"
            :md="8"
            :lg="6"
            :xl="4"
            v-for="o in tableList"
            :key="o.id"
            style="margin-bottom: 18px"
          >
            <el-card
              class="elCard"
              shadow="hover"
              :body-style="{ padding: '0px' }"
            >
              <span
                class="selectStates"
                :class="
                  selectionList.indexOf(o.templateId) > -1
                    ? 'selectedState'
                    : 'noSelected'
                "
                v-if="multipleSelect"
                @click="ids(o.templateId)"
              >
                <i class="checkIcon el-icon el-icon-check"></i>
              </span>
              <!-- 模板开放状态 
                 // 模板开放类型(0: 所属门店可见1: 所属商户可见 2: 所属用户可见 3: 所有人可见 4: 所属代理商可见)
              -->
              <span class="format" v-if="o.openType == '3'">
                {{ $t("lcd.Template.System Template") }}
              </span>
              <span class="format" v-if="o.openType == '1'">
                {{ $t("lcd.Template.Merchant Template") }}
              </span>
              <span class="format" v-if="o.openType == '0'">
                {{ $t("lcd.NewAdd.Store Template") }}
              </span>

              <div style="width: 100%; padding: 8px 10px; position: relative">
                <span class="auditSpan" v-if="o.activeState == 5301"> {{o.activeStateDesc}} </span>
                <span
                  class="auditSpan"
                  v-if="o.activeState == 5302"
                  style="background-color: rgba(53, 184, 113, 0.12); color: #35B871"
                >
                  {{o.activeStateDesc}}
                </span>
                <!-- {{ o.templateImageUrlList }} -->
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    overflow: hidden;
                    position: relative;
                  "
                >
                  <img
                    src="@/assets/img/800AD.png"
                    v-if="o.isAddMarketPostion == 1 && o.width == 800"
                    :style="{
                      margin: '0 auto',
                      'min-height': '120px',
                      height: imgWidth + 'px',
                      position: 'absolute',
                      'z-index': 0,
                    }"
                  />
                  <img
                    src="@/assets/img/1280AD.png"
                    v-if="o.isAddMarketPostion == 1 && o.width == 1280"
                    :style="{
                      width: '100%',
                      // margin: '0 auto',
                      // 'min-height': '100px',
                      height: 'auto',
                      position: 'absolute',
                      'z-index': 0,
                    }"
                  />
                  <div
                    class="materialWrap"
                    @click="imgClick(o)"
                    :style="{
                      cursor: 'pointer',
                      'min-height': '120px',
                      height: imgWidth + 'px',
                      'background-image':
                        'url(' +
                        o.templateImageUrlList[
                          o.templateImageUrlList.length - 1
                        ] +
                        ')',
                      'background-size': 'contain',
                      'background-position': 'center',
                      'background-repeat': 'no-repeat',
                    }"
                  >
                    <video
                      @click="imgClick(o)"
                      v-if="o.format == 'mp4'"
                      :style="{
                        'max-width': '100%',
                        'max-height': imgWidth + 'px',
                        'min-height': '120px',
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                      }"
                      :src="o.originalUrl"
                    ></video>
                  </div>
                </div>
              </div>
              <div class="imageName">
                <span>{{ o.templateName }}</span>
                <el-popover
                  placement="top"
                  trigger="hover"
                  popper-class="customPopper"
                >
                  <div
                    class="templateBtnList"
                    v-if="
                      (o.openType == '3' && userData.userRoleId == 1) ||
                      (o.openType == '0' && userData.userRoleId == 4 && o.storeId == currentStoreId) ||
                      (o.openType == '1' && userData.userRoleId == 4) ||
                      (o.openType == '4' && userData.userRoleId == 2) ||
                      (o.openType == '0' && userData.userRoleId == 5) 
                    "
                  >
                    <el-button
                      class="templateBtn"
                      type="text"
                      icon="el-icon-edit"
                      @click="addPopClick(o, 'edit')"
                    >
                      {{ $t("lcd.Template.EditInfo") }}
                    </el-button>
                  </div>
                  <!-- currentStoreId:{{currentStoreId}} -->
                  <div
                    class="templateBtnList"
                    v-if="
                      (o.openType == '3' && userData.userRoleId == 1) ||
                      (o.openType == '0' && userData.userRoleId == 4) ||
                      (o.openType == '1' && userData.userRoleId == 4) ||
                      (o.openType == '4' && userData.userRoleId == 2) ||
                      (o.openType == '0' && userData.userRoleId == 5)
                    "
                  >
                    <!-- 
                      模板编辑
                      模板开放类型{
                        0: 所属门店可见
                        1: 所属商户可见 
                        2: 所属用户可见 
                        3: 所有人可见 
                        4: 所属代理商可见
                      }
                    -->
                    <el-button
                      class="templateBtn"
                      type="text"
                      icon="el-icon-edit"
                      @click="editClick(o)"
                    >
                      {{ $t("lcd.Template.Edit") }}
                    </el-button>
                  </div>
                  <div class="templateBtnList">
                    <el-button
                      class="templateBtn"
                      type="text"
                      icon="el-icon-copy-document"
                      @click="addPopClick(o, 'copy')"
                    >
                      {{ $t("lcd.Template.Copy") }}
                    </el-button>
                  </div>
                  <div
                    class="templateBtnList"
                    v-if="
                      (o.openType == '3' && userData.userRoleId == 1) ||
                      (o.openType == '0' && userData.userRoleId == 4) ||
                      (o.openType == '1' && userData.userRoleId == 4) ||
                      (o.openType == '4' && userData.userRoleId == 2) ||
                      (o.openType == '0' && userData.userRoleId == 5)
                    "
                  >
                    <el-button
                      class="templateBtn"
                      type="text"
                      icon="el-icon-position"
                      @click="handlePublish(o)"
                    >
                      {{ $t("lcd.Template.Publish") }}
                    </el-button>
                  </div>
                  <!-- <div class="templateBtnList">
                    <el-button
                      class="templateBtn"
                      type="text"
                      icon="el-icon-document"
                      >详情</el-button
                    >
                  </div> -->
                  <div
                    class="templateBtnList"
                    v-if="
                      (o.openType == '3' && userData.userRoleId == 1) ||
                      (o.openType == '0' && userData.userRoleId == 4) ||
                      (o.openType == '1' && userData.userRoleId == 4) ||
                      (o.openType == '4' && userData.userRoleId == 2) ||
                      (o.openType == '0' && userData.userRoleId == 5)
                    "
                  >
                    <el-button
                      class="templateBtn"
                      type="text"
                      icon="el-icon-delete"
                      @click="handelDelete(o)"
                      >{{ $t("lcd.Template.Delete") }}</el-button
                    >
                  </div>
                  <el-button
                    slot="reference"
                    class="copyButton"
                    icon="el-icon-more"
                    type="text"
                    style="color: #35b871; background-color: #f5f5f5"
                  ></el-button>
                </el-popover>
              </div>
              <div class="templateInfo">
                <span>{{ o.width }}-{{ o.height }}</span>
                <el-tooltip
                  :content="$t('lcd.Template.Marketing Num')"
                  placement="bottom"
                  effect="dark"
                  v-if="o.isAddMarketPostion == 1"
                >
                  <el-button type="text" class="infoBtn"
                    ><airplay-icon
                      size="1x"
                      class="custom-class"
                    ></airplay-icon>
                    1
                  </el-button>
                </el-tooltip>
                <el-tooltip
                  :content="`${$t('lcd.Template.Max Number of Items')}${o.itemQty}`"
                  placement="bottom"
                  effect="dark"
                >
                  <el-button type="text" class="infoBtn"
                    ><shopping-bag-icon
                      size="1x"
                      class="custom-class"
                    ></shopping-bag-icon>
                    {{ o.itemQty }}
                  </el-button>
                </el-tooltip>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div v-if="tableList.length < 1">
        <el-empty
          :image-size="200"
          :description="this.$t('lcd.noData')"
        ></el-empty>
      </div>
      <pagination :tableInfo="tableInfo" @changePage="changePage" />
    </div>
    <!-- 操作确认弹窗 -->
    <confirm-dialog
      :dialogVisible="isVisibleConfirmDialog"
      @handleClose="handelConfirmDialog"
      :confirmObj="confirmObj"
    >
    </confirm-dialog>

    <!-- 素材预览弹窗 -->
    <preview-template
      :dialogVisible="previewVisible"
      @handleClose="handleClosePreview"
      :previewObj="previewObj"
    ></preview-template>
    <!-- 新建/复制营销模板弹窗 -->
    <add-pop
      ref="addPopRef"
      :flag="flag"
      :editData="editData"
      :copyData="copyData"
      :labelTypeList="labelTypeList"
      @reGetList="reGetList"
    >
    </add-pop>

    <!-- 超管添加模板自动运营AddAutoTemplate -->
    <AddAutoTemplate ref="addAutoTemplateRef"></AddAutoTemplate>
    <!-- 超管查看模板自动运营历史 -->
    <AutoTemplateList ref="autoTemplateListRef"></AutoTemplateList>
  </div>
</template>
<script>
import { commonStore } from "@/store/global-select-store";
import {
  RepeatIcon,
  ShieldOffIcon,
  AirplayIcon,
  ShoppingBagIcon,
} from "vue-feather-icons";
import pagination from "@/components/pagination";
import ConfirmDialog from "@/components/confirm-dialog/index.vue";
import PreviewTemplate from "../components/previewTemplate.vue";
import AddPop from "../components/addPop.vue";
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口
import AddAutoTemplate from "../components/addAutoTemplate.vue";
import AutoTemplateList from "../components/autoTemplatList.vue";

import {
  getPixels,
  deleteMaterial,
  getTemplateList,
  getTemplateInfo,
  createInfo,
  updateInfo,
  copyInfo,
  activeInfo,
  unActiveInfo,
  saveJson,
  deleteInfo,
} from "@/libs/api/lcd";

// import {
//     checkPerm,
//     checkRole
// } from "@/utils/permission"; // 权限判断函数

export default {
  data() {
    return {
      commonStore,
      userData: JSON.parse(localStorage.getItem("userData")),
      currentStoreId: localStorage.getItem("storeId"),
      flag: "add",
      editData: {},
      copyData: {},
      multipleSelect: true,
      selectionList: [], // 多选数据
      activeName: "first",
      pageParams: {
        templateGroupId: "1", // 0：价签模板 1：营销模板
        templateName: "", // 模板名称
        templateSize: "", // 分辨率
        usageState: "", // 使用状态 (已使用/未使用）
        activeState: "", // 激活状态(待发布/已发布)
        labelType: "",
        current: "1",
        size: "10",
      },
      initPageParams: {
        templateGroupId: "1", // 0：价签模板 1：营销模板
        templateName: "", // 模板名称
        templateSize: "", // 分辨率
        usageState: "", // 使用状态 (已使用/未使用）
        activeState: "", // 激活状态(待发布/已发布)
        current: "1",
        size: "10",
      },
      previewVisible: false,
      previewObj: {},
      imgWidth: 0,
      stateList: [], // 素材审核状态list
      formatList: [], // 图片格式类型
      labelTypeList:[], // 模板标签类型列表
      activeStateList: [], // 模板发布状态
      pixelsList: ["800*1280", "1280*800"],
      currentRow: {}, // 当前操作的对象
      auditVisible: false, // 审核弹窗可见性
      auditObj: {}, //  审核弹窗数据

      batchAuditVisible: false, // 批量审核弹窗
      isVisibleConfirmDialog: false, // 确认弹窗可见性
      confirmObj: {
        type: this.$t("devices.tips"),
        cancelText: this.$t("devices.cancel"),
        confirmText: this.$t("devices.sure"),
        content: this.$t("devices.esl.repushTips"),
        loading: false,
      },
      currentConfirmType: "",

      loading: true,
      tableInfo: {
        current: 1,
        size: 10,
        total: 0,
      },
      tableList: [], // item 表格list
      storeType: "2",
      storeOption: [
        { id: "2", value: this.$t("itemsScenarios.ThisStore") },
        { id: "4", value: this.$t("itemsScenarios.LastStore") },
        { id: "1", value: this.$t("itemsScenarios.ZimenStore") },
        { id: "0", value: this.$t("itemsScenarios.AllStore") },
      ], // 商店list
      visible: false,
      multipleSelection: [],
      init: true, // 是否首次进入页面
      initTemplateInfo: {
        activeState: "",
        isAddMarketPostion: 0,
        itemQty: 4,
        openType: 3,
        templateGroup: 1,
        templateId: "",
        templateName: "",
        templateSize: "800*1280",
        width: 800,
        height: 1280,
        bgColor: "",
        bgImg: "",
        scale: 1,
        pages: [],
      },
    };
  },
  components: {
    AirplayIcon,
    ShoppingBagIcon,
    RepeatIcon,
    ShieldOffIcon,
    PreviewTemplate,
    AddPop,
    pagination,
    ConfirmDialog,
    AddAutoTemplate,
    AutoTemplateList,
  },
  computed: {
    language() {
      return this.$store.state.appConfig.language;
    },
  },
  watch: {
    // currentStoreId: {
    //   handler(val) {
    //     console.log('val=======currentStoreId',val)
    //     this.$router.go(0)
    //   },
    // },
  },
  mounted() {
    this.getList();
    this.getEnum(52)
    this.getEnum(53)
    setTimeout(() => {
      this.setImgHeight();
    }, 500);
    commonStore.setInjectCallBack(this.getList);
  },
  methods: {
    async getEnum(id) {
      const params = {
        cateId: id,
      };
      try {
        const { data } = await getCodeList(params);
        if (data.state === true) {
          let arr = data.data || [];
          if (id == 39) {
            this.stateList = arr; // 素材审核状态list
          } else if (id == 40) {
            this.groupList = arr; // 素材分组list
          } else if (id == 41) {
            this.formatList = arr; // 图片格式类型list
          } else if (id == 52) {
            this.labelTypeList = arr  // 模板标签列表list
          } else if  (id == 53) {
            this.activeStateList = arr // 发布状态列表list
          } 
        } else {
          this.$message.error(data.message);
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
    getList() {
      // TODO 获取数据
      this.selectionList = [];
      this.tableList = [];
      this.currentStoreId = localStorage.getItem('storeId')
      // 获取素材列表
      const params = {
        ...this.pageParams,
        current: this.tableInfo.current,
        size: this.tableInfo.size,
      };
      getTemplateList(params).then((res) => {
        console.log(res);
        res.data.data.records.forEach((item) => {
          item.templateImageUrlList = item.templateImageUrl
            ? item.templateImageUrl.split(",")
            : [];
        });
        this.tableList = res.data.data.records;
        this.tableInfo.total = res.data.data.total;
      });
    },
    // 翻页
    changePage() {
      this.getList();
    },
    setImgHeight() {
      let el = document.getElementsByClassName("materialWrap")[0];
      console.log(el);
      this.imgWidth = el.offsetWidth;
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      this.pageParams = this.initPageParams;
      this.getList();
    },
    imgClick(obj) {
      // TODO
      console.log(123);
      this.previewObj = obj;
      this.previewVisible = true;
    },
    handleClosePreview() {
      this.previewObj = {};
      this.previewVisible = false;
    },

    getData() {
      // TODO 上传、修改完成后需要重新获取列表数据
      console.log(123);
      this.getList();
    },
    // 编辑营销模板
    editClick(row) {
      console.log(row);
      const query = {
        templateId: row.templateId,
      };
      const params = {
        templateId: row.templateId,
      };
      getTemplateInfo(params).then((res) => {
        console.log(res.data.data.svgValue);
        // console.log('解绑模板',res.data.data)
        if (!res.data.data.svgValue && res.data.data.templateGroup == 1) {
          // console.log("解绑模板");
          for (let i = 0; i < res.data.data.itemQty + 1; i++) {
            this.initTemplateInfo.pages.push({
              id: i + 1,
              title:
                i == 0
                  ? this.$t("lcd.Template.Unbind Template")
                  : i + this.$t("lcd.Template.Items Num"),
              componentList: [],
              imgId: null,
              bgImg: "",
              bgColor: "rgba(255,255,255,0)",
              customScript: "",
              duration: 10,
              groupNum: 1,
              itemNum: i,
            });
          }

          this.initTemplateInfo = {
            ...this.initTemplateInfo,
            ...res.data.data,
          };
        }
        console.log(res.data.data.svgValue);
        console.log(this.initTemplateInfo);

        // JSON.stringify(res.data.data)
        // localStorage.setItem(
        //   "templateInfo",
        //   res.data.data.svgValue
        //     ? res.data.data.svgValue
        //     : JSON.stringify(this.initTemplateInfo)
        // );
        const toEditor = this.$router.resolve({
          path: `/editor`,
          query: query,
        });
        console.log(toEditor);
        window.open(toEditor.href, "_blank");
      });
    },

    handelDelete(row) {
      this.currentRow = row;
      this.confirmObj.content = `${this.$t(
        "lcd.Template.Confrim Delete PopTemplate"
      )}-${row.templateName}`;
      this.isVisibleConfirmDialog = true;
      this.currentConfirmType = "templateDelete";
    },

    doDelete() {
      console.log("templateDelete");
      // 删除素材
      const params = {
        templateId: this.currentRow.templateId,
      };
      console.log(params);
      deleteInfo(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t("devices.deleteSuccess"));
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
        this.confirmObj.loading = false;
        this.isVisibleConfirmDialog = false;
      });
    },

    handelConfirmDialog(val) {
      console.log(val);
      if (val === "confirm") {
        const { currentConfirmType } = this;

        this.confirmObj.loading = true;
        if (currentConfirmType === "templateDelete") {
          // 素材删除
          this.doDelete();
        }
      } else {
        this.isVisibleConfirmDialog = false;
        this.confirmObj.loading = false;
      }
    },

    // 素材审核相关

    openAuditDialog(row) {
      this.auditObj = row;
      this.auditVisible = true;
    },
    handleCloseAudit() {
      this.auditObj = {};
      this.auditVisible = false;
    },
    openBatchAuditDialog() {
      this.batchAuditVisible = true;
    },
    handleCloseBatchAudit() {
      // this.selectionList = [];
      this.batchAuditVisible = false;
    },
    reGetList() {
      this.auditObj = {};
      this.auditVisible = false;
      this.batchAuditVisible = false;
      this.selectionList = [];
      this.getList();
    },

    // 素材列表多选功能
    indexOf(val, ids) {
      for (let i = 0; i < ids.length; i++) {
        if (ids[i] == val) {
          return i;
        }
      }
      return -1;
    },
    // ids
    ids(id) {
      let index = this.indexOf(id, this.selectionList);
      if (this.selectionList.length > 0 && index > -1) {
        this.selectionList.splice(index, 1);
      } else {
        this.selectionList.push(id);
      }
    },
    allSelectClick() {
      if (this.selectionList.length < this.tableList.length) {
        this.selectionList = [];
        this.tableList.map((item) => {
          this.selectionList.push(item.templateId);
        });
      } else {
        this.selectionList = [];
        console.log("取消");
      }
    },

    /***
     * pop template
     * 营销模板相关
     * **/
    // 新建复制编辑营销模板信息
    addPopClick(data, flag) {
      this.editData = {};
      this.copyData = {};
      console.log(data);
      this.flag = "";
      this.flag = flag;
      if (data.templateId && flag == "edit") {
        this.editData = data;
      }
      if (data.templateId && flag == "copy") {
        this.copyData = data;
      }
      this.$nextTick().then(() => {
        this.$refs.addPopRef.open();
      });
    },
    handlePublish(row) {
      console.log(row);
      const params = {
        templateId: row.templateId,
      };
      activeInfo(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t('lcd.Template.Publish Success'));
          this.getList();
        } else {
          this.$message.error(this.$t('lcd.Template.Publish Error'));
        }
      });
    },

    // 打开add auto tempate 
    openAutoTemplateDialog() {
      this.$refs.addAutoTemplateRef.open();
    },
    
    // autoTemplateList
    autoTemplateList(){
      this.$refs.autoTemplateListRef.open();
    }
  },
};
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

.items-wrap {
  .top {
    height: 70px;
    padding: 20px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    margin-bottom: 20px;
    background: #fff;
    .left {
      float: left;
      .new-btn,
      .update-btn,
      .more-btn,
      .delete-btn {
        border-radius: 6px;
        color: #fff;
        position: relative;
        padding: 9px 15px;
      }
      // .el-icon-check,.el-icon-delete{
      //   position: absolute;
      //   left: 20px;
      // }
      .new-btn {
        width: 85px;
        background: #3461ff;
      }
      .update-btn {
        // width: 190px;
        background: #3461ff;
      }
      .more-btn {
        // width: 140px;
        background: #3461ff;
      }
      .delete-btn {
        // width: 135px;
        background: #fc174d;
      }
    }
    .right {
      float: right;
      .import-btn,
      .export-btn,
      .share-btn {
        background: #eeeeee;
        border: 1px solid #eeeeee;
        border-radius: 6px;
        color: #666666;
      }
      .import-btn,
      .export-btn,
      .share-btn {
        width: 80px;
      }
    }
  }
  .center {
    position: relative;
    background: #fff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    // padding: 16px 28px;
    .refresh {
      background: #35b871;
      border: none;
      padding: 6px 8px;
      border-radius: 4px;
      color: #fff;
      float: right;
      margin-right: 10px;
    }
    ::v-deep .el-popover {
      position: absolute;
      right: 20px;
      width: 100px;
      height: 150px;
      cursor: pointer;
    }
    .center-title {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 3;
      padding: 13px 20px;
      .number {
        font-size: 12px;
      }
    }
    ::v-deep .el-table {
      .is-group tr:nth-child(2) .el-checkbox {
        display: none;
      }
      .is-group tr:last-child .el-checkbox {
        display: none;
      }
      .date-cell {
        width: 350px;
        .el-date-editor {
          width: 140px;
        }
      }
      .el-icon-help,
      .el-icon-edit {
        font-size: 18px;
        width: 14px;
        cursor: pointer;
      }
      .el-icon-edit {
        margin: 0 17px;
      }
      .el-table__cell {
        text-align: center;
      }
    }
  }
}

// #35B871
.elCard {
  position: relative;
  .materialWrap {
    width: 100%;
    overflow: hidden;
    position: relative;
    // background-color: #f5f5f5;
  }
  .materialImage,
  .materialVideo {
    // max-width: 100%;
    // max-height: 100%;
    width: auto;
    height: auto;
    cursor: pointer;
    // left: 50%;
  }
  .format {
    position: absolute;
    top: 5px;
    right: 5px;
    width: auto;
    text-align: center;
    padding: 2px 5px;
    border-radius: 20px;
    z-index: 8;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.2);
  }
  .imageInfo {
    line-height: 12px;
    padding: 3px 10px 0;
    position: relative;
    color: #c2c2c2;
    font-size: 12px;
  }
  .imageName {
    line-height: 16px;
    font-size: 13px;
    height: 36px;
    padding: 2px 40px 2px 10px;
    text-align: justify;
    display: flex;
    align-items: center;
    position: relative;
    // background-color: pink;
    .copyButton {
      position: absolute;
      right: 10px;
      bottom: 5px;
      padding: 4px;
      font-size: 12px;
    }
  }
}
.elCard:hover {
  border: 1px solid #1dd670;
}
::v-deep .el-popper .popper__arrow::after {
  border-right-color: rgb(253, 30, 30) !important;
}
::v-deep .el-popover__reference {
  display: flex !important;
  align-items: center !important;
}
::v-deep .el-table--border,
.el-table--group {
  border: none !important;
}
::v-deep .el-textarea__inner {
  height: 34px;
}
::v-deep .el-button + .el-button {
  margin: 0;
}
.materialImage ::v-deep .el-image__error,
.el-image__inner,
.el-image__placeholder {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: aoto;
}
.templateBtnList {
  width: 100%;
  text-align: center;
  padding: 3px;
  .templateBtn {
    padding: 2px;
    font-size: 13px;
    color: #35b871;
  }
}
.auditSpan {
  padding: 5px 8px;
  background-color: #ecf5ff;
  color: #409eff;
  position: absolute;
  border-radius: 4px 0 0 4px;
  right: 0;
  bottom: 0;
  z-index: 2;
  font-size: 12px;
}
.checkboxCard {
  position: absolute;
  top: 10px;
  left: 10px;
  ::v-deep .el-checkbox__inner {
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
  }
  ::v-deep .el-checkbox__inner::after {
    left: 6px;
    top: 2px;
  }
}
.allSelectBtn {
  padding: 5px 10px;
  font-size: 12px;
  margin-right: 12px;
}
.selectStates {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 10px;
  left: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  background-color: #fff;
  cursor: pointer;
  z-index: 2;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  &:hover {
    border: 1px solid #3461ff;
  }
}
.selectedState {
  background-color: #3461ff;
  border: 1px solid #3461ff;

  .checkIcon {
    color: #fff;
  }
}
.templateInfo {
  font-size: 12px;
  padding: 2px 10px 10px;
  color: #aaa;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.infoBtn {
  color: #aaa;
  padding: 0;
  font-size: 12px;
  border: none;
  .custom-class {
    font-size: 13px;
  }
}
</style>
<style>
.customPopper.el-popover {
  min-width: 10px !important;
}
</style>
